export const en = {
  translation: {
    auth: {
      notAMember: "Not a member?",
      signUp: "Sign Up",
      up: "Up",
      business: "Business",
      signIn: "Sign In",
      signInDescription: "Sign in If you have an account in here",
      alreadyHaveAccount: "Already have an account?",
      signUpDescription: "Sign up if you don't have an account",
    },
    businessSignIn: {
      emailLabel: "Your Email",
      emailPlaceholder: "Email",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter Your Password",
      forgotPassword: "Forgot Password?",
      signInButton: "Sign In",
      orSignInWith: "Or Sign in with",
      invalidEmail: "Invalid email address",
      emailRequired: "Email is required",
      passwordMinLength: "Password must be at least 6 characters long",
      passwordRequired: "Password is required",
    },
    businessSignUp: {
      firstNameLabel: "First Name",
      firstNamePlaceholder: "Enter Your First Name",
      lastNameLabel: "Last Name",
      lastNamePlaceholder: "Enter Your Last Name",
      emailLabel: "Your Email",
      emailPlaceholder: "Email",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter Your Password",
      confirmPasswordLabel: "Confirm Password",
      confirmPasswordPlaceholder: "Confirm Your Password",
      signUpButton: "Sign Up",
      orSignUpWith: "Or Sign up with",
      google: "Google",
      facebook: "Facebook",
      twitter: "Twitter",
      apple: "Apple",
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      emailRequired: "Email is required",
      passwordRequired: "Password is required",
      confirmPasswordRequired: "Confirm password is required",
      invalidEmail: "Invalid email address",
      passwordMinLength: "Password must be at least 6 characters long",
      passwordsMustMatch: "Passwords must match",
    },
    forgotPassword: {
      title: "Forgot Password",
      subtitle: "Forgot your password? Let's get you back on the track.",
      emailLabel: "Your Email",
      emailPlaceholder: "Email",
      nextButton: "Next",
      rememberedAccount: "Remembered your account?",
      invalidEmail: "Invalid email address",
      emailRequired: "Email is required",
      errorMessage: "An error occurred",
    },
    verifyOtp: {
      verify: "Verify",
      otp: "OTP",
      subtitle: "Enter the OTP sent to your email to continue",
      enterOtpLabel: "Enter OTP",
      enterOtpPlaceholder: "Enter 4-digit code",
      resendOtp: "Resend OTP",
      rememberedAccount: "Remembered your account?",
      next: "Next",
      otpRequired: "OTP is required",
      otpLength: "OTP must be 4 digits",
      otpResent: "OTP has been resent to your email",
      errorMessage: "An error occurred",
    },
    resetPassword: {
      title: "Reset",
      password: "Password",
      subtitle: "Reset your password? Let's get you back on the track.",
      newPasswordLabel: "New Password",
      newPasswordPlaceholder: "Enter New Password",
      confirmPasswordLabel: "Confirm Password",
      confirmPasswordPlaceholder: "Confirm Password",
      resetButton: "Reset",
      rememberedAccount: "Remembered your account?",
      passwordRequired: "Password is required",
      confirmPasswordRequired: "Confirm Password is required",
      passwordMinLength: "Password must be at least 8 characters",
      passwordsMustMatch: "Passwords must match",
      successMessage:
        "Password reset successfully! Please sign in with your new password.",
      errorMessage: "An error occurred",
    },
    splitLayout: {
      logo: "LOGO",
      logoAlt: "LOGO",
      reviewsWebsite: "Reviews Website",
      reviewsManagementSystem: "Reviews Management System",
      affiliateDescription:
        "Join our affiliate network and earn commissions by helping businesses discover our platform. Connect local businesses with customers and earn rewards for every successful subscription.",
    },
    passwordSettings: {
      title: "Password Settings",
      currentPassword: "Current Password",
      currentPasswordPlaceholder: "Enter your current password",
      newPassword: "New Password",
      newPasswordPlaceholder: "Enter your new password",
      confirmNewPassword: "Confirm New Password",
      confirmNewPasswordPlaceholder: "Confirm your new password",
      changePassword: "Change Password",
      currentPasswordRequired: "Current password is required",
      newPasswordRequired: "New password is required",
      confirmPasswordRequired: "Please confirm your new password",
      passwordMinLength: "Password must be at least 8 characters",
      passwordDifferentFromCurrent:
        "New password must be different from current password",
      passwordsMustMatch: "Passwords must match",
    },
    businessCard: {
      status: {
        live: "Live",
        pending: "Pending",
        draft: "Draft",
        rejected: "Rejected",
      },
      aboutLabel: "About",
      reviews: "Reviews",
      review: "Review",
      manageBusiness: "Manage Business",
      manageBusinessAria: "Open settings for {{name}}",
    },
    businessStatus: {
      title: "Business Status",
      changeStatus: "Change Status",
      cancel: "Cancel",
      update: "Update",
      newStatus: "New Status",
      selectNewStatus: "Select new status",
      success: "Success",
      updateSuccess: "Business status updated successfully",
      error: "Error",
      updateError: "Failed to update business status",
      rejectedWarning:
        "Rejected businesses are not visible to customers. Please review your business information and resubmit for approval.",
      descriptions: {
        draft: "Your business is in draft mode and not visible to the public.",
        pending: "Your business is under review and will be published soon.",
        published: "Your business is live and visible to customers.",
        rejected: "Your business was rejected. Please review and resubmit.",
      },
      labels: {
        draft: "Draft",
        pending: "Pending review",
        published: "Live",
        rejected: "Rejected",
      },
    },
    customColorPicker: {
      pickAColor: "Pick a color",
    },
    colorsForm: {
      colors: "Colors",
      primary: "Primary",
      background: "Background",
      card: "Card",
      text: "Text",
      textOnPrimary: "Text on Primary",
    },
    galleryManagement: {
      gallery: "Gallery",
      addImages: "Add Images",
      uploadImages: "Upload Images",
      selectImages: "Select Images",
      chooseMultipleImages: "Choose multiple images",
      cancel: "Cancel",
      upload: "Upload",
      galleryImage: "Gallery image",
      noImagesUploadedYet: "No images uploaded yet",
      uploadImagesToShowcase: "Upload images to showcase your business",
      success: "Success",
      error: "Error",
      imagesUploadedSuccessfully: "Images uploaded successfully",
      failedToUploadImages: "Failed to upload images",
      imageDeletedSuccessfully: "Image deleted successfully",
      failedToDeleteImage: "Failed to delete image",
    },
    operationHours: {
      title: "Operation Hours",
      previewBlurb: "When you're open each week. Update these in the Hours tab if they change.",
      edit: "Edit",
      cancel: "Cancel",
      save: "Save",
      open: "Open",
      closed: "Closed",
      openTime: "Open time",
      closeTime: "Close time",
      to: "to",
      success: "Success",
      updateSuccess: "Operation hours updated successfully",
      error: "Error",
      updateError: "Failed to update operation hours",
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
    },
    operationTimes: {
      title: "Operation Times",
      from: "From",
      to: "To",
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
    },
    renderStars: {
      rating: "Rating",
      stars: "Stars",
    },
    dashboard: {
      openMenu: "Open menu",
      closeMenu: "Close menu",
      businesses: "Businesses",
      shop: "Shop",
      reviews: "Reviews",
      offers: "Offers",
      settings: "Settings",
      logout: "Logout",
      confirmLogout: "Confirm Logout?",
      logoutMessage: "Do you want to exit from app?",
      keepUsingApp: "No, keep using app",
      yes: "Yes",
    },
    createBusiness: {
      title: "Create New Business",
      businessName: "Business Name",
      businessNamePlaceholder: "Business Name",
      businessCategory: "Business Category",
      selectCategoryPlaceholder: "Select a category",
      create: "Create",
    },
    businesses: {
      title: "Businesses",
      noBusinessesYet: "No businesses yet",
      getStartedDescription:
        "Get started by creating your first business and start managing your reviews",
      createFirstBusiness: "Create Your First Business",
      addNewBusiness: "Add New Business",
      websiteUsage: "Websites used: {{used}} / {{allowed}}",
      websiteLimitReachedTitle: "Website limit reached",
      websiteLimitReachedDescription:
        "You have reached the maximum number of websites for your current subscription plan. Go to Subscription settings to upgrade and add more websites.",
      manageSubscriptionButton: "Manage subscription",
      viewGrid: "Grid",
      viewTable: "Table",
      viewModeAria: "Business list layout",
      table: {
        business: "Business",
        status: "Status",
        category: "Category",
        location: "Location",
        reviews: "Reviews",
        actions: "Actions",
      },
    },
    businessReviews: {
      businessReviews: "Business Reviews",
      totalReviews: "Total Reviews",
      reviewImageFullView: "Review image full view",
      reviewImage: "Review image",
      reviewImages: "Review Images",
      more: "more",
      business: "Business",
      unknownBusiness: "Unknown business",
      noReviewsFound: "No reviews found",
      page: "Page",
      of: "of",
      showing: "Showing",
      reviews: "reviews",
      errorLoadingReviews: "Error Loading Reviews",
      failedToLoadReviews: "Failed to load reviews. Please try again.",
      generateAIReply: "Generate AI Reply",
      postReply: "Post Reply",
      replyPlaceholder: "Write your reply...",
      businessReply: "Business Reply",
      aiReplyGenerated: "AI Reply Generated",
      editAndPostReply: "Edit the reply if needed and click Post Reply",
      replyPosted: "Reply posted successfully",
      replyCannotBeEmpty: "Reply cannot be empty",
      failedToGenerateReply: "Failed to generate AI reply. Please try again.",
      failedToPostReply: "Failed to post reply. Please try again.",
      error: "Error",
      success: "Success",
      sendOffer: "Send Offer",
    },
    offers: {
      title: "Loyalty Offers",
      totalOffers: "Total Offers",
      noOffersFound: "No offers found",
      errorLoading: "Error Loading Offers",
      failedToLoad: "Failed to load offers. Please try again.",
      success: "Success",
      error: "Error",
      markedRedeemed: "Offer marked as redeemed",
      failedToRedeem: "Failed to mark offer as redeemed. Please try again.",
      redeemed: "Redeemed",
      active: "Active",
      markRedeemed: "Mark as Redeemed",
      business: "Business",
      expires: "Expires",
      sentAt: "Sent",
      page: "Page",
      of: "of",
      showing: "Showing",
      offers: "offers",
    },
    loyaltyCards: {
      title: "Loyalty Cards",
      totalCards: "Total Cards",
      noCardsFound: "No loyalty cards found",
      errorLoading: "Error Loading Loyalty Cards",
      failedToLoad: "Failed to load loyalty cards. Please try again.",
      stamps: "stamps",
      rewardsEarned: "Rewards earned",
    },
    loyaltySettings: {
      title: "Loyalty Program",
      subtitle:
        "Reward customers who leave repeated positive reviews with an automatic offer once they reach a stamp threshold.",
      enable: "Enable loyalty program",
      threshold: "Stamps required for a reward",
      thresholdDescription: "Number of positive reviews (4+ stars) needed to earn a reward.",
      description: "Reward Description",
      expiryDays: "Reward expires after (days)",
      expiryDaysDescription: "How many days the auto-generated offer stays valid.",
      save: "Save Settings",
      success: "Success",
      error: "Error",
      saved: "Loyalty program settings saved",
      failedToSave: "Failed to save loyalty program settings. Please try again.",
      errorLoading: "Error Loading Settings",
      failedToLoad: "Failed to load loyalty program settings. Please try again.",
    },
    sendOffer: {
      title: "Send Loyalty Offer",
      subtitle: "Send a special offer to {{name}} to reward their review",
      offerType: "Offer Type",
      selectOfferType: "Select offer type",
      types: {
        discount: "Discount",
        freeItem: "Free Item",
        other: "Other",
      },
      description: "Offer Description",
      descriptionPlaceholder: "Describe the offer (e.g. 20% off next visit, free dessert...)",
      expiryDate: "Expiry Date",
      selectDate: "Select expiry date",
      cancel: "Cancel",
      send: "Send Offer",
      success: "Success",
      error: "Error",
      offerSent: "Offer sent to customer successfully",
      failedToSend: "Failed to send offer. Please try again.",
      fillAllFields: "Please fill in all fields",
    },
    businessSettings: {
      title: "Settings",
      privacy: "Privacy",
      business: "Business",
      loyalty: "Loyalty",
      subscription: "Subscription",
    },
    subscription: {
      status: {
        active: "Active",
        canceled: "Canceled",
        cancelled: "Canceled",
        past_due: "Past due",
        incomplete: "Incomplete",
        trialing: "Trialing",
        unpaid: "Unpaid",
        paused: "Paused",
        unknown: "Unknown",
      },
      invoiceStatus: {
        paid: "Paid",
        open: "Open",
        draft: "Draft",
        void: "Void",
        uncollectible: "Uncollectible",
        unknown: "Unknown",
      },
      current: {
        title: "Current Subscription",
        plan: "Plan",
        price: "Price",
        month: "month",
        nextPayment: "Next Payment",
        cancelWarning:
          "Your subscription will be cancelled at the end of the current billing period.",
        cancelButton: "Cancel Subscription",
        noSubscription: {
          title: "No Active Subscription",
          description: "You don't have an active subscription",
        },
      },
      billing: {
        title: "Billing History",
        table: {
          invoice: "Invoice",
          date: "Date",
          amount: "Amount",
          status: "Status",
          actions: "Actions",
        },
        actions: {
          viewInvoice: "View Invoice",
          payNow: "Pay Now",
          processing: "Processing...",
        },
        noInvoices: {
          title: "No Invoices",
          description: "You don't have any billing history yet",
        },
      },
      cancelModal: {
        title: "Cancel Subscription",
        description:
          "Are you sure you want to cancel your subscription? You will continue to have access until the end of your current billing period.",
        warning:
          "This action cannot be undone. Your subscription will be cancelled immediately and you will not be charged for future billing periods.",
        keepButton: "Keep Subscription",
        cancelButton: "Cancel Subscription",
      },
      notifications: {
        cancelled: {
          title: "Subscription Cancelled",
          message: "Your subscription has been cancelled successfully.",
        },
        error: {
          title: "Error",
          message: "Failed to cancel subscription. Please try again.",
        },
        paymentSuccess: {
          title: "Payment Successful",
          message: "Invoice has been paid successfully.",
        },
        paymentFailed: {
          title: "Payment Failed",
          message: "Failed to pay invoice. Please try again.",
        },
      },
      error: {
        title: "Error Loading Subscription",
        message: "Failed to load subscription information. Please try again.",
      },
    },
    contactInformation: {
      title: "Contact Information",
      websiteUrlLabel: "Website URL",
      websiteUrlPlaceholder: "Website URL",
      googleUrlLabel: "Google URL",
      googleUrlPlaceholder: "Google URL",
      facebookUrlLabel: "Facebook URL",
      facebookUrlPlaceholder: "Facebook URL",
      twitterUrlLabel: "Twitter URL",
      twitterUrlPlaceholder: "Twitter URL",
      iphoneUrlLabel: "Iphone URL",
      iphoneUrlPlaceholder: "Iphone URL",
      phoneLabel: "Phone #",
      phonePlaceholder: "Phone #",
    },
    contactInfo: {
      title: "Contact Information",
      website: "Website",
      email: "Email",
      callUs: "Call Us",
      getDirections: "Get Directions",
      openInMaps: "Open in Google Maps",
      emptyTitle: "No contact details yet",
      emptyHint: "Add phone, email, website, or social links — they'll show here instantly.",
      clickToAdd: "Click to add contact information",
      socialMedia: {
        title: "Social Media",
        facebook: "Facebook",
        twitter: "Twitter",
        instagram: "Instagram",
        linkedin: "LinkedIn",
        youtube: "YouTube",
        tiktok: "TikTok",
        snapchat: "Snapchat",
      },
    },
    faqs: {
      title: "FAQs",
      question1Label: "Question 1",
      question1Placeholder: "Question 1",
      question2Label: "Question 2",
      question2Placeholder: "Question 2",
      answerLabel: "Answer",
      answer1Placeholder: "Answer 1",
      answer2Placeholder: "Answer 2",
    },
    faqsSection: {
      title: "Frequently Asked Questions",
      intro: "Clear answers reduce repeats and help visitors decide faster.",
      untitledQuestion: "Question",
      edit: "Edit",
      addFAQs: "Add FAQs",
      emptyTitle: "No questions yet",
      emptyStateMessage:
        "Add questions and answers in the editor — they'll appear here for visitors.",
    },
    faqsSectionForm: {
      title: "Edit FAQs Section",
      question: "Question",
      questionPlaceholder: "Enter your question",
      answer: "Answer",
      answerPlaceholder: "Enter your answer",
      remove: "Remove",
      addFAQ: "Add FAQ",
      cancel: "Cancel",
      save: "Save",
      validation: {
        questionRequired: "Question is required",
        answerRequired: "Answer is required",
      },
    },
    generalInformation: {
      title: "General Information",
      logo: "Logo",
      coverImage: "Cover Image",
      businessName: "Business Name",
      businessNamePlaceholder: "Business Name",
      aboutUs: "About Us",
      aboutUsPlaceholder: "About Us",
      address: "Address",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      country: "Country",
      state: "State",
      city: "City",
      zipCode: "Zip Code",
      addressPlaceholder: "Address",
      zipCodePlaceholder: "123444",
    },
    imagesForm: {
      title: "Images",
      importFromInstagram: "Import from instagram",
      uploadImages: "Upload Images",
      uploadedPhoto: "Uploaded photo",
      selected: "Selected",
      remove: "Remove",
    },
    aboutUs: {
      emptyTitle: "About section is empty",
      emptyHint: "Tell visitors what makes your business different — add your story in the editor.",
      title: "About Us",
      clickToAddStory: "Click to add your business story",
    },
    aboutUsForm: {
      editHeroSection: "Edit Hero Section",
      aboutUs: "About Us",
      cancel: "Cancel",
      save: "Save",
      businessNameRequired: "Business Name is required",
    },
    colorsSection: {
      primaryColor: "Primary Color",
      backgroundColor: "Background Color",
      cardColor: "Card Color",
      textColor: "Text Color",
    },
    colorsSectionForm: {
      editColorsSection: "Edit Colors Section",
      primaryColor: "Primary Color",
      backgroundColor: "Background Color",
      cardColor: "Card Color",
      textColor: "Text Color",
      textOnPrimaryColor: "Text on Primary Color",
      save: "Save",
      validation: {
        primaryColorRequired: "Primary color is required",
        backgroundColorRequired: "Background color is required",
        cardColorRequired: "Card color is required",
        textColorRequired: "Text color is required",
        textOnPrimaryColorRequired: "Text on primary color is required",
      },
    },
    contactInfoForm: {
      title: "Edit Contact Information",
      basicContact: "Basic Contact",
      socialMedia: "Social Media",
      websiteUrl: "Website URL",
      websiteUrlPlaceholder: "https://www.yourwebsite.com",
      emailAddress: "Email Address",
      emailAddressPlaceholder: "contact@yourbusiness.com",
      phoneNumber: "Phone Number",
      phoneNumberPlaceholder: "+1 (555) 123-4567",
      googleUrl: "Google Maps URL (map on your page)",
      googleUrlPlaceholder:
        "Paste embed iframe, or a https://www.google.com/maps/... link",
      googleUrlDescription:
        "Used only for the map block / \"open in Google Maps\" on your public listing. Prefer Share → Embed a map (see guide); a full Place page link from the address bar also works.",
      googleReviewUrl: "Google Reviews link",
      googleReviewUrlPlaceholder:
        "https://search.google.com/local/writereview?placeid=…",
      googleReviewUrlDescription:
        "Used only when we invite customers to post on Google after they submit a review here. Paste the writereview link (recommended) or a normal Maps link—leave empty to reuse your Maps URL above instead.",
      googleUrlGuideTitle: "How to add your map (recommended)",
      googleUrlGuideIntro:
        "Using \"Embed a map\" avoids most copy/paste mistakes. You can also paste a normal Place link from the browser address bar.",
      googleUrlStep1: "Open Google Maps in a browser (desktop is easiest).",
      googleUrlStep2:
        "Search for your business or move the map until the pin matches your location.",
      googleUrlStep3: "Click Share.",
      googleUrlStep4: "Choose \"Embed a map\" (not only \"Send a link\").",
      googleUrlStep5:
        "Copy the full iframe code, or copy only the long https://www.google.com/maps/... URL inside src=\"...\".",
      googleUrlStep6:
        "Paste into the field below and click Save. Then scroll the preview and check the map loads.",
      googleUrlTestHint: "Need to open Maps?",
      googleUrlOpenMapsLink: "Open Google Maps",
      googleReviewsGuideTitle: "How to set the Google Reviews link",
      googleReviewsGuideIntro:
        "This is separate from the map: it only controls where the \"Open Google Reviews\" button goes after someone submits a review on Reword.",
      googleReviewsStep1:
        "Best: paste Google's direct review URL (starts with https://search.google.com/local/writereview?placeid=). You can get it from Google Business Profile or by opening your place on Maps and using the review / share options.",
      googleReviewsStep2:
        "Or paste a normal Google Maps link or short maps.app.goo.gl link—we'll open the review flow when possible.",
      googleReviewsStep3:
        "If you leave this empty, we fall back to your Maps URL above. If the button stays disabled, use a full maps.google.com / google.com/maps place link or the writereview URL.",
      facebookUrl: "Facebook URL",
      facebookUrlPlaceholder: "https://facebook.com/yourbusiness",
      twitterUrl: "Twitter URL",
      twitterUrlPlaceholder: "https://twitter.com/yourbusiness",
      instagramUrl: "Instagram URL",
      instagramUrlPlaceholder: "https://instagram.com/yourbusiness",
      linkedinUrl: "LinkedIn URL",
      linkedinUrlPlaceholder: "https://linkedin.com/company/yourbusiness",
      youtubeUrl: "YouTube URL",
      youtubeUrlPlaceholder: "https://youtube.com/@yourbusiness",
      tiktokUrl: "TikTok URL",
      tiktokUrlPlaceholder: "https://tiktok.com/@yourbusiness",
      snapchatUrl: "Snapchat URL",
      snapchatUrlPlaceholder: "https://snapchat.com/add/yourbusiness",
      cancel: "Cancel",
      save: "Save",
      validation: {
        websiteUrlInvalid: "Please enter a valid URL",
        emailInvalid: "Please enter a valid email",
        googleUrlInvalid: "Please enter a valid URL",
        googleUrlNotGoogleMaps:
          "Use a Google Maps URL (e.g. google.com/maps or maps.google.com), a Google short link (maps.app.goo.gl / goo.gl), or paste the embed iframe from Google Maps.",
        googleReviewUrlInvalid:
          "Use a Google Maps or short Maps link, or a https://search.google.com/local/writereview… link.",
        facebookUrlInvalid: "Please enter a valid URL",
        twitterUrlInvalid: "Please enter a valid URL",
        instagramUrlInvalid: "Please enter a valid URL",
        linkedinUrlInvalid: "Please enter a valid URL",
        youtubeUrlInvalid: "Please enter a valid URL",
        tiktokUrlInvalid: "Please enter a valid URL",
        snapchatUrlInvalid: "Please enter a valid URL",
      },
    },
    footerSection: {
      tagline: "Quick links and social profiles visitors use to reach you.",
      businessDescription: "Business description",
      socialMedia: {
        facebook: "Facebook",
        twitter: "Twitter",
        google: "Google",
        instagram: "Instagram",
        linkedin: "LinkedIn",
        youtube: "YouTube",
        tiktok: "TikTok",
        snapchat: "Snapchat",
      },
      all: "All",
      rightsReserved: "Rights Reserved",
    },
    footerSectionForm: {
      title: "Edit Contact Information",
      websiteUrl: "Website URL",
      websiteUrlPlaceholder: "https://www.example.com",
      emailAddress: "Email Address",
      emailAddressPlaceholder: "contact@example.com",
      phoneNumber: "Phone Number",
      phoneNumberPlaceholder: "+1 (555) 123-4567",
      googleUrl: "Google Maps URL (map on your page)",
      googleUrlPlaceholder:
        "Paste embed iframe, or a https://www.google.com/maps/... link",
      googleReviewUrl: "Google Reviews link",
      googleReviewUrlPlaceholder:
        "https://search.google.com/local/writereview?placeid=…",
      twitterUrl: "Twitter URL",
      twitterUrlPlaceholder: "https://twitter.com/...",
      facebookUrl: "Facebook URL",
      facebookUrlPlaceholder: "https://facebook.com/...",
      instagramUrl: "Instagram URL",
      instagramUrlPlaceholder: "https://instagram.com/...",
      linkedinUrl: "LinkedIn URL",
      linkedinUrlPlaceholder: "https://linkedin.com/...",
      youtubeUrl: "YouTube URL",
      youtubeUrlPlaceholder: "https://youtube.com/...",
      tiktokUrl: "TikTok URL",
      tiktokUrlPlaceholder: "https://tiktok.com/...",
      snapchatUrl: "Snapchat URL",
      snapchatUrlPlaceholder: "https://snapchat.com/...",
      cancel: "Cancel",
      save: "Save",
      validation: {
        websiteUrlInvalid: "Invalid URL",
        emailInvalid: "Invalid email address",
        googleUrlInvalid: "Invalid URL",
        twitterUrlInvalid: "Invalid URL",
        facebookUrlInvalid: "Invalid URL",
        instagramUrlInvalid: "Invalid URL",
        linkedinUrlInvalid: "Invalid URL",
        youtubeUrlInvalid: "Invalid URL",
        tiktokUrlInvalid: "Invalid URL",
        snapchatUrlInvalid: "Invalid URL",
      },
    },
    gallery: {
      title: "Gallery",
      manageImages: "Manage Images",
      remove: "Remove",
      galleryImageAlt: "Gallery photo",
      imageUnavailable: "Image could not be loaded",
      noImagesYet: "No Images Yet",
      emptyVisitor: "Photos you upload will appear here on your public page.",
      clickToAddPhotos: "Click \"Manage Images\" to add photos to your gallery",
    },
    galleryForm: {
      editGallery: "Edit Gallery",
      addImages: "Add Images",
      cancel: "Cancel",
      save: "Save",
    },
    heroSection: {
      coverImageAlt: "Cover image for {{name}}",
      reviews: "{{count}} Reviews",
      randomLocation: "Random Location",
      writeReview: "Write a review",
      ratingLine: "{{score}} average (published reviews)",
      noRatingYet: "Average rating appears after reviews are published",
      addressPlaceholder: "Your address shows here once you add it in the editor",
      noCoverTitle: "Cover photo",
      noCoverHint: "Upload a cover image under Profile & location to show it here.",
      businessNameFallback: "Your business name",
      logoPlaceholderAria: "No logo uploaded",
    },
    heroSectionForm: {
      title: "Edit Hero Section",
      uploadLogo: "Upload Logo",
      uploadCoverImage: "Upload Cover Image",
      businessName: "Business Name",
      businessNamePlaceholder: "Business Name",
      address: "Address",
      address1: "Address Line 1",
      address1Placeholder: "Enter address line 1",
      address2: "Address Line 2",
      address2Placeholder: "Enter address line 2 (optional)",
      city: "City",
      cityPlaceholder: "Enter city",
      state: "State/Province",
      statePlaceholder: "Enter state or province",
      country: "Country",
      countryPlaceholder: "Enter country",
      zip: "ZIP/Postal Code",
      zipPlaceholder: "Enter ZIP or postal code",
      cancel: "Cancel",
      save: "Save",
      validation: {
        businessNameRequired: "Business Name is required",
        address1Required: "Address Line 1 is required",
        cityRequired: "City is required",
        stateRequired: "State/Province is required",
        countryRequired: "Country is required",
        zipRequired: "ZIP/Postal Code is required",
      },
    },
    reviewCard: {
      title: "Review",
      outOf5: "out of 5",
      stars: "Stars",
    },
    reviewCard2: {
      sampleReview: {
        name: "Sarah Johnson",
        comment:
          "Absolutely fantastic service! The team went above and beyond to meet our needs. Professional, timely, and the quality exceeded our expectations. Highly recommend to anyone looking for reliable business solutions.",
      },
    },
    reviewsHighlight: {
      title: "Ratings",
      subtitle:
        "Average from published reviews on your live page. New ratings appear after customers post and content is published.",
      averageLabel: "Average {{score}} out of 5",
      noReviewsYet: "No published average yet — scores appear when reviews go live",
    },
    timingSection: {
      operationTimes: "Operation Times",
      notSet: "Not set",
      closed: "Closed",
      clickToSetHours: "Click to set your business hours",
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
    },
    timingSectionForm: {
      title: "Business Hours",
      open: "Open",
      openTime: "Open",
      closeTime: "Close",
      cancel: "Cancel",
      save: "Save",
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
    },
    businessProfileSetup: {
      loading: "Loading...",
    },
    unifiedBusinessEdit: {
      modalTitle: "Edit business details",
      modalHint: "Use the tabs to update your page; the preview reflects edits before you save.",
      tabProfile: "Profile & location",
      tabAbout: "About",
      tabContact: "Contact & social",
      tabTheme: "Theme",
      tabGallery: "Gallery",
      tabFaqs: "FAQs",
      tabHours: "Hours",
    },
    businessWebsitePreview: {
      pageTitle: "Your business page",
      pageSubtitle:
        "Edit on the left — the preview updates as you type. On smaller screens, your form appears first, then the preview below.",
      locationTitle: "Location",
      locationBlurb:
        "Help people visit you in person. Add a Google Maps link under Contact & social to show a map here.",
      mapEmbedHint: "For an inline map, use Google Maps → Share → Embed. A normal link still opens in Google Maps.",
      editDetails: "Edit details",
      qrCode: "QR code",
      qrCodeTitle: "Page QR code",
      publishWebsite: "Publish Website",
      pendingApproval: "Pending Approval",
      markAsDraft: "Mark as Draft",
      statusDraft: "Draft",
      statusPending: "Pending review",
      statusPublished: "Published",
      statusRejected: "Rejected",
      googleMap: "Google map",
      mapEmbedHelp:
        "This link is not an embed URL. Use Share → Embed a map in Google Maps for an inline map, or keep this link for the Open in Google Maps button.",
      mapOpenInGoogleMaps: "Open in Google Maps",
      mapNoLocation: "No map added yet",
      mapPlaceholderHint:
        "Paste a Google Maps link or embed under Contact & social so visitors can find you.",
      downloadQRCode: "Download QR Code",
    },
    completeSubscription: {
      user: "User",
      logout: "Logout",
      chooseSubscriptionPlan: "Choose Your Subscription Plan",
      plansLoadErrorTitle: "Could not load plans",
      plansLoadErrorBody:
        "Billing could not be reached. Check your connection or try again.",
      retry: "Retry",
      plansEmpty:
        "No subscription plans match this app (products need Websites metadata in Stripe).",
      perMonthPerSeat: "/month",
      noDescriptionAvailable: "No description available",
      paymentMethod: "Payment Method",
      orderSummary: "Order Summary",
      plan: "Plan",
      amount: "Amount",
      termsAndPrivacyText: "By clicking Subscribe, you agree to our",
      termsAndConditions: "Terms and Conditions",
      and: "and",
      privacyPolicy: "Privacy Policy",
      subscribeNow: "Subscribe Now!",
      promotionCodeLabel: "Promotion code (optional)",
      promotionCodePlaceholder: "Enter code if you have one",
      promotionCodeHint:
        "Beta partners: enter the code on Premium for two months free, then normal billing.",
      promotionCodeHintCheckout:
        "Optional: enter here for Premium, or enter a promotion code on Stripe's checkout page. Beta: two months free on Premium, then normal billing.",
      continueToCheckout: "Continue to secure checkout",
    },
    subscriptionCheckout: {
      syncing: "Updating your account…",
      successTitle: "Subscription activated",
      successBody:
        "Your payment was successful. You can continue to the dashboard.",
      sessionRef: "Checkout reference",
      continueToDashboard: "Continue to dashboard",
      syncError: "We could not refresh your account. Sign in again or try later.",
      signInAgain: "Sign in",
      cancelTitle: "Checkout cancelled",
      cancelBody:
        "No payment was completed. You can return to plans and try again when you are ready.",
      backToPlans: "Back to subscription plans",
    },
    paymentMethods: {
      title: "Payment Details",
      addCard: "Add Card",
      noCardsAdded: "No cards added.",
      default: "Default",
      expiry: "Exp:",
    },
    pageNotFound: {
      title:
        "Looks like you've gotten lost! The page you requested is unavailable",
      homeLink: "Head back to the homepage.",
      imageAlt: "Page not found",
    },
    paymentInformation: {
      cancel: "Cancel",
      addCard: "Add Card",
      loading: "Loading…",
      loadError: "Could not load the form. Check your connection and try again.",
      stripeNotConfigured:
        "Stripe is not configured. Set VITE_STRIPE_PUBLISHABLE_KEY in your environment.",
    },
    shop: {
      title: "Shop",
      subtitle: "Buy NFC cards and signs for your business.",
      nfcCards: "NFC Cards",
      nfcSigns: "NFC Signs",
      addToCart: "Add to cart",
      quantity: "Quantity",
      cart: "Your cart",
      remove: "Remove",
      total: "Total",
      clearCart: "Clear cart",
      checkout: "Checkout",
      shippingDescription: "Enter your shipping address. Required to place the order.",
      continueToPayment: "Continue to payment",
      placeOrder: "Place order",
      orderPlacedTitle: "Order placed",
      orderPlacedMessage: "We have received your order. You will receive a confirmation email.",
      errorCreatingPayment: "Could not create payment.",
      errorPayment: "Payment failed.",
      validation: {
        line1Required: "Address line 1 is required",
        cityRequired: "City is required",
        postalCodeRequired: "Postal code is required",
        countryRequired: "Country is required",
      },
      shipping: {
        line1: "Address line 1",
        line1Placeholder: "Street address",
        line2: "Address line 2",
        line2Placeholder: "Apartment, suite, etc. (optional)",
        city: "City",
        cityPlaceholder: "City",
        postalCode: "Postal code",
        postalCodePlaceholder: "Postal code",
        state: "State / Region",
        statePlaceholder: "State or region (optional)",
        country: "Country",
        countryPlaceholder: "Country",
      },
    },
    paywall: {
      subscription: "Subscription",
      renewDescription:
        "Your subscription requires attention. Please pay any outstanding invoices or update your payment method to restore full access to your account.",
      addPaymentMethod: "Add a payment method to continue",
      payInvoice: "Pay Invoice",
      paidOn: "Paid On",
      summary: "Summary",
      to: "TO",
      from: "FROM",
      invoice: "Invoice",
      items: "Items",
      qty: "Qty",
      each: "Each",
      subtotal: "Subtotal",
      totalDue: "Total Due",
      amountPaid: "Amount Paid",
      amountRemaining: "Amount Remaining",
      payNow: "Pay Now",
      noInvoices: "No outstanding invoices found.",
    },
  },
};
